import { Component } from '@angular/core';
import { AuthService } from '../../.providers/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
	constructor(public auth: AuthService, public router: Router) {}
	ngOnInit() {}

	logout() {
		this.router.navigate(['/login']);
		localStorage.removeItem('user');
		window.location.reload();
	}
	
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/shared/sidebar/sidebar.component.ts